import { apiClient } from './apiClient'

function getStore() {
    return apiClient().get('/store/')
}

export default {
    getStore
}
